// extracted by mini-css-extract-plugin
export var animate = "Mark-module--animate--3691f";
export var animated = "Mark-module--animated--c4d38";
export var mark = "Mark-module--mark--d8710";
export var normal = "Mark-module--normal--e11e2";